import { render, staticRenderFns } from "./FormattedTextInput.vue?vue&type=template&id=a5659796&"
import script from "./FormattedTextInput.vue?vue&type=script&lang=js&"
export * from "./FormattedTextInput.vue?vue&type=script&lang=js&"
import style0 from "./FormattedTextInput.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports